// components/RequireAuth.tsx
import { LOCAL_STORAGE_KEYS } from '@command-center-app/constants/common.const';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const RequireAuth = () => {
  const location = useLocation();
  const token = localStorage.getItem(LOCAL_STORAGE_KEYS.JWT_TOKEN);

  return token
    ? <Outlet />
    : <Navigate to="/auth/login" state={{ from: location }} replace />;
};

export default RequireAuth;
